export const GET_FW_TOKEN = "getFwToken"
export const GET_FW_TOKEN_TIMESTAMP = "getFwTokenTimestamp"
export const GET_USER = "getUser"

export default {
  [GET_FW_TOKEN]: (state: Auth): string => state.fw_token,
  [GET_FW_TOKEN_TIMESTAMP]: (state: Auth): number => state.fw_token_timestamp,
  [GET_USER]: (state: Auth): Object | null => state.user
}
